import type { QueryClient, QueryKey } from '@tanstack/react-query';

/**
 * The queries the dashboard (Panou) and the shell's live numbers are drawn
 * from. They are cached for one to five minutes, so without being told, Panou
 * went on showing 0 „Programate azi" and 0 „Pacienți noi" right after the
 * first booking of the day. Prefixes: React Query matches a key that starts
 * with one, so `['dash-appts']` covers every day's entry.
 */
export const DASHBOARD_QUERY_KEYS: readonly QueryKey[] = [
  ['dashboard'],
  ['shell', 'dashboard'],
  ['dash-appts'],
  ['dash-week'],
  ['waitlist', 'summary'],
];

/** Marks every dashboard query stale; the ones on screen refetch at once. */
export function invalidateDashboard(queryClient: QueryClient): Promise<void> {
  return Promise.all(
    DASHBOARD_QUERY_KEYS.map((queryKey) => queryClient.invalidateQueries({ queryKey })),
  ).then(() => undefined);
}

/**
 * Whether a successful write changes what the dashboard counts: anything done
 * to an appointment (book, move, change status, cancel, restore, attach a
 * patient), and anything done to a patient (a new one is a „Pacient nou").
 */
export function writeTouchesDashboard(method: string, path: string): boolean {
  if (method.toUpperCase() === 'GET') return false;
  const clean = path.split('?')[0];
  return /^\/(appointments|patients)(\/|$)/.test(clean);
}

/** Wires the API client's write notifications to the dashboard's queries. */
export function dashboardWriteListener(queryClient: QueryClient) {
  return (method: string, path: string) => {
    if (writeTouchesDashboard(method, path)) void invalidateDashboard(queryClient);
  };
}
